// extracted by mini-css-extract-plugin
export default {"main":"CheckoutLandingPage_main__iy7BI","main_activate":"CheckoutLandingPage_main_activate__8y4+W"};